import Button from "@pathwright/ui/src/components/button/Button"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import { ConnectStores } from "lib/core/store"
import AnaltyicsAvatarsStack from "./AnaltyicsAvatarsStack"
import "./PostPathAnalytics.css"

const PostPathAnalytics = function ({ label, analytics }) {
  if (!analytics || !analytics.complete || analytics.complete < 1) {
    return null
  }

  return (
    <div className="PostPathAnalytics">
      <Button styleType="blank" inverted>
        <AnaltyicsAvatarsStack
          analytics={analytics}
          limit={5}
          itemWidth="1.6em"
          itemOffset="-0.4em"
        />
        <span style={{ marginLeft: "5px" }}>{label}</span>
      </Button>
    </div>
  )
}

PostPathAnalytics.displayName = "PostPathAnalytics"

const mapStateToProps = (state, ownProps) => {
  const { t } = ownProps
  const { path_analytics } = state.pathAnalyticsStore.state

  const analytics = {
    ...path_analytics,
    // There's currently a gap in path analytics on the backend. The `students_here`
    // list is not recalculated after a learner syncs their path. If that learner already
    // completed the path, or if that learner had previously synced an empty path, they would
    // be listed in `students_here`, but would remain even after syncing their path and would
    // only be removed after performing some kind of completion action.
    students_here: path_analytics.students_here?.slice(
      0,
      path_analytics.complete
    )
  }

  const label =
    (analytics != null ? analytics.complete : undefined) > 0
      ? t("path.analytics.number_completed", { qty: analytics.complete })
      : t("path.analytics.no_one_completed")

  return _.assign(
    {},
    {
      label,
      analytics,
      t
    },
    ownProps
  )
}

const stores = [{ store: "pathAnalytics", watch: ["path_analytics"] }]

export default withTranslate(
  ConnectStores(PostPathAnalytics, stores, {}, mapStateToProps)
)
